var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCallOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8224 9.57171L11.1293 8.73379C10.5267 8.54577 9.80887 8.83758 9.42306 9.42662C9.10952 9.90481 8.61286 10.2548 8.09446 10.3629C7.73908 10.4368 7.40543 10.3873 7.15492 10.2238C6.0464 9.49943 5.11556 8.57131 4.38904 7.46659C4.22493 7.21663 4.17494 6.88407 4.24939 6.52977C4.35752 6.013 4.70856 5.51797 5.18892 5.20497C5.77905 4.82025 6.07139 4.10514 5.88338 3.50414L5.04274 0.819767C4.8569 0.224748 4.25102 -0.107268 3.6022 0.0312983L1.01781 0.581216C0.962925 0.592627 0.908043 0.607299 0.853703 0.625774L0.74611 0.665442C0.713507 0.679027 0.679816 0.695329 0.645039 0.714347C0.251077 0.929532 -0.00214599 1.34632 1.37067e-05 1.77614C0.00328801 2.33693 0.0375222 2.89717 0.101643 3.44274L0.078276 3.63021L0.0788196 3.63075V3.6313L0.132616 3.68509C0.518971 6.5439 1.73129 9.05874 3.64404 10.9661C5.59755 12.9136 8.1852 14.1319 11.1288 14.4905C11.6912 14.559 12.2699 14.5954 12.8486 14.5992C12.8508 14.5992 12.853 14.5992 12.8557 14.5992C13.2975 14.5992 13.7327 14.3319 13.9414 13.9308C13.955 13.9037 13.9675 13.8776 13.9778 13.8526C14.0142 13.7651 14.0425 13.6743 14.0615 13.5852L14.613 11.0074C14.7511 10.3607 14.4185 9.757 13.8224 9.57171Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCallOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/call-on.b0d5325a9de508005222a70d06c6fe7b.svg";